/**
 * Booked private cars, on top of the Detail Queue.
 *
 * A private job starts as a quote. Once the customer says yes and a day is
 * agreed, the car shows up here so a detailer can pick it up the same way
 * they pick a dealership car — and the services already agreed come with it,
 * so nobody has to remember what was sold.
 *
 * No money on this card. The detailer never sees what the customer pays, and
 * a quote total here would be the one place it leaked.
 */

import React, { useState, useEffect } from 'react';
import { api } from '../api';

const NAVY = '#1e3a4a', LINE = '#e5e7eb', MUTED = '#6b7280';
const today = () => new Date().toISOString().slice(0, 10);

export default function PrivateBookings({ onPick }) {
  const [cars, setCars] = useState([]);

  useEffect(() => {
    api.bookedPrivateCars().then(setCars).catch(() => setCars([]));
  }, []);

  if (!cars.length) return null;

  return (
    <div style={{ marginBottom: 18 }}>
      <div style={{ fontSize: 11, fontWeight: 800, color: '#9D4EDD', letterSpacing: 0.7, textTransform: 'uppercase', marginBottom: 8 }}>
        Private · booked
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(230px, 1fr))', gap: 10 }}>
        {cars.map(c => {
          const when = c.scheduled_date ? String(c.scheduled_date).slice(0, 10) : null;
          const due  = when && when <= today();
          return (
            <button
              key={c.id}
              onClick={() => onPick({
                stock_number: c.stock_number, model: c.model, colour: c.colour,
                private: true, private_quote_id: c.id, services: c.services || [],
              })}
              style={{
                textAlign: 'left', cursor: 'pointer', background: '#fff',
                border: `1.5px solid ${due ? '#9D4EDD' : LINE}`, borderRadius: 12,
                padding: 12, font: 'inherit',
              }}
            >
              <div style={{ fontSize: 14, fontWeight: 800, color: NAVY }}>
                {c.stock_number || '—'} <span style={{ fontWeight: 600 }}>{c.model}</span>
              </div>
              <div style={{ fontSize: 12, color: MUTED, marginTop: 2 }}>{c.client_name}</div>
              <div style={{ fontSize: 11.5, color: '#4A7A91', marginTop: 6, fontWeight: 600 }}>
                {(c.services || []).join(' · ') || 'no services listed'}
              </div>
              <div style={{ fontSize: 11, color: due ? '#9D4EDD' : MUTED, marginTop: 6, fontWeight: 700 }}>
                {when ? (due ? `booked ${when} — today or overdue` : `booked ${when}`) : 'no day yet'}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
